export default "__VITE_ASSET__CHWzEN9D__"